var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M140 110.009 73.505 43.514c-4.685-4.685-12.28-4.685-16.966 0L43.514 56.539c-4.685 4.685-4.685 12.28 0 16.966L110.009 140l-66.495 66.495c-4.685 4.685-4.685 12.28 0 16.965l13.025 13.027c4.685 4.684 12.28 4.684 16.966 0L140 169.99l66.495 66.496c4.685 4.684 12.28 4.684 16.965 0l13.027-13.027c4.684-4.684 4.684-12.28 0-16.965L169.99 140l66.496-66.495c4.684-4.685 4.684-12.28 0-16.966L223.46 43.514c-4.684-4.685-12.28-4.685-16.965 0z"
})));
export default SvgClose;